export const PROFILE_SELECTED = 'PROFILE_SELECTED';
export const PROFILES = {
  1: 'HRC PMO',
  2: 'Branch Chief',
  3: 'Contractor Team Lead',
  4: 'Development Team Lead',
  5: 'Administrator'
};
export const DEFAULT_PROFILE_ID = '1';
